module.exports = __webpack_public_path__ + "static/sui-table-text-align-470f4c815502766eb63ab01f8872f1dc.png";